export default __webpack_public_path__ + "static/media/pencil.b8d0c0d0.png";